const filters = document.querySelectorAll('.jobs-filter, .cars-filter, .filter');

for (let i = 0; i < filters.length; i++) {
    filters[i].addEventListener('change', (event) => {
        document.getElementById('filters').submit();
    })
}
